interface CalculateRollCountProps {
  wallWidth: number;
  wallHeight: number;
  rollWidth: number;
  rollLength: number;
  patternSize: number;
  fitment: number;
}

export function calculateRollCount({
  wallWidth,
  wallHeight,
  rollWidth,
  rollLength,
  patternSize,
  fitment,
}: CalculateRollCountProps) {
  if (patternSize <= 0 || fitment == 0) patternSize = 1;

  const numCoverings = Math.ceil(wallWidth / rollWidth); // antal våder
  const numFullRepeats = Math.floor(wallHeight / patternSize);
  const leftOfLastReport =
    (wallHeight / patternSize - numFullRepeats) * patternSize;
  const repeatFitment = fitment == 0 ? patternSize : patternSize * fitment;
  let waste =
    repeatFitment > leftOfLastReport
      ? repeatFitment - leftOfLastReport
      : patternSize - leftOfLastReport + repeatFitment; // skärsmån mellan våder (spill)

  if (fitment == 0) {
    waste = 0;
  }

  let numRolls = 0;
  let leftOfCurrentRoll = rollLength;

  // Not beautiful, should be refactored to not use a loop, if possible
  for (let i = 0; i < numCoverings; i++) {
    if (leftOfCurrentRoll == rollLength) {
      numRolls++;
    }

    leftOfCurrentRoll = leftOfCurrentRoll - wallHeight;
    if (fitment != 0) {
      leftOfCurrentRoll = leftOfCurrentRoll - waste;
    }

    if (leftOfCurrentRoll < wallHeight) {
      if (fitment == 0 && waste == 0) {
        waste = leftOfCurrentRoll;
      }
      leftOfCurrentRoll = rollLength;
    }
  }

  const coveringsPerRoll = Math.ceil(numCoverings / numRolls);

  return {
    rolls: numRolls,
    waste: waste ?? 0,
    coveringsPerRoll,
    totalCoverings: numCoverings,
  };
}

export function getFitment(patternMatch: string) {
  switch (patternMatch) {
    case '1':
    default:
      return 0;
    case '2':
      return 1;
    case '3':
      return 0.5;
    case '4':
      return 0.33;
    case '5':
      return 0.2;
  }
}
